import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { ResourceAppProps } from "./resource";
import { RessPass } from "./ressPassInGrid";
import React from "react";

export interface RessPalaInGridProps extends ResourceAppProps {
    ressPass: RessPass;
    loadAll: () => void;
}

export default class RessPalaInGrid extends React.Component<RessPalaInGridProps, {
    gridData: RessPala[]
}>{
    private gridOptions = {};
    editableGridRef: EditableGrid;

    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        };
        this.gridOptions = this.props.context.ressPalaInGridOptions;
    }

    componentDidMount() {
        this.bindToSaveSuccessfully();
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.ressPass?.Passnr != this.props.ressPass?.Passnr) {
            this.setState({});
        }
    }

    public deleteByRessPass = (ressPassItems: RessPass[]) => {
        let gridData = this.state.gridData;
        for (let ressPass of ressPassItems) {
            gridData = gridData.filter(x => x.PassNr != ressPass.Passnr);
        }
        this.setState({ gridData: gridData });
    }

    private bindToSaveSuccessfully = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.loadData();
        });
    }

    private loadData = async () => {
        let url = "Resource/GetGridRessPalaData?ressNr=" + encodeURIComponent(this.props.entity.Ressnr);
        const result = await HTTPService.get<JsonResultClass<RessPala[]>>(url)
        if (result.Code == 0) {
            this.props.entity.RessPalasLoaded = true;
            this.setState({ gridData: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private createNewEntity = (): RessPala => {
        let entity: RessPala = {
            PseudoId: kendo.guid(),
            RessNr: this.props.entity.Ressnr,
            PassNr: this.props.ressPass?.Passnr,
            Date: new Date(),
            IsNew: true
        }
        return entity;
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let newItem: RessPala = this.createNewEntity();
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
            case "reload":
                if (Helper.hasValue(this.props.loadAll))
                    this.props.loadAll();
                break;
        }
    }

    render() {
        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit" });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "reload",
            caption: Helper.getTranslation("Standard.Alle"),
            enabled: () => this.props.entity.RecordRight.CanRead
        })

        let filter: kendo.data.DataSourceFilterItem = null;
        if (Helper.hasValue(this.props.ressPass)) {
            filter = {
                field: "PassNr",
                operator: "eq",
                value: this.props.ressPass.Passnr
            }
        }

        let schema = new Schema();
        schema.Id = "PseudoId";
        schema.fields["PseudoId"] = new field("string");
        return <div style={{ display: "flex", flexDirection: "column", height: "50%" }}>
            <EditableGrid data={this.state.gridData}
                id="ressPalaInGrid"
                schema={schema}
                gridOptions={this.gridOptions}
                ref={(ref) => this.editableGridRef = ref}
                editable={this.props.entity.RecordRight.CanWrite}
                onDataChanged={() => this.props.context.setEntityDirtyState(true)}
                filters={filter}
                filterable={true}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                {...this.props} helpEditUrl={this.props.helpUrl}
            />
        </div>

    }
}

export interface RessPala {
    PseudoId?: string;
    RessNr?: string;
    PassNr?: string;
    Country?: string;
    Date?: Date;
    IsNew?: boolean;
}